import { render, staticRenderFns } from "./bankList.vue?vue&type=template&id=78147916&scoped=true"
import script from "./bankList.vue?vue&type=script&lang=js"
export * from "./bankList.vue?vue&type=script&lang=js"
import style0 from "./bankList.vue?vue&type=style&index=0&id=78147916&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78147916",
  null
  
)

export default component.exports